import React, { Component }     from "react";
import { Button, PageHeader, DropdownButton, MenuItem, Panel, Row,Tab, Tabs, Col } from "react-bootstrap";
import { FontAwesomeIcon }      from '@fortawesome/react-fontawesome'
import BootstrapTable           from 'react-bootstrap-table-next';
import ModalCreateFolder        from "../../components/modal/ModalCreateFolder";
import ModalMoveProgramToFolder from "../../components/modal/ModalMoveProgramToFolder";
import ModalTrainerDetail       from "../../components/modal/ModalTrainerDetail";
import ModalAlert               from "../../components/modal/ModalAlert";
import ModalProgramOverview     from "../../components/modal/ModalProgramOverview";
import uniqueId                 from 'lodash/uniqueId';
import config                   from "../../config";
import RenderLander             from "../../components/utils/RenderLander";
import BillingForm              from "../../screens/billing/BillingForm";
import { Colors }               from "../../utils/Colors";
import ModalTrainerTextMsg                 from "../../components/modal/ModalTrainerTextMsg";
import { invokeGetProgramOverview,
         invokeGetClientProgramList}   from "../../utils/AwsInvoke";
import { doesTrainerHaveValidPhoneNumber } from "../../utils/CheckIfValidPhoneNumber";
import "../../css/client/datagridClientProgram.css";

/*function priceFormatter(column, colIndex) {
  return (
    <h5><strong>{ column.text }</strong></h5>
  );
}
const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    hideSelectColumn: true,
    bgColor: "#fff"
};*/

var program_list_arr     = [];
//var template_details_arr = []; ///*{id: 1,name: "Product1",price: 120,}*/

//  ALL HTML tags MUST be removed for the SORT feature to work on a table  //
const columns_prog = [{
    dataField: "program_name",
    text: "Program",
    sort: true,
    headerStyle: () => {
        return { width: "75%", textAlign: "center", outline: 0, border: 0 };
    }
},{
    dataField: "link",
    text: "Full Program",
    headerStyle: () => {
        return { width: "15%", textAlign: "center" };
    }
},{
    dataField: "overview",
    text: "Overview",
    headerStyle: () => {
        return { width: "15%", textAlign: "center" };
    }
},{
    dataField: "date",
    text: "Date",
    //sort: true,
    headerStyle: () => {
        return { width: "10%", textAlign: "center" };
    }
}];


export default class TableClientProgram extends Component {
    constructor(props) {
        super(props);

        this.state = {
          isLoading: true,
          //showModalTrainerTextMsg: false,
          //showModalTrainerDetail: false,
          showModalProgramOverview: false
        };
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            this.getClientPrograms();

        } catch (e) {
            alert(e);
        }
    }

    componentWillUnmount () {
        program_list_arr = [];
    }

    getClientPrograms = async () => {
        var client_id   = this.props.clientId;
        var client_name = this.props.clientName;

        const results     = await invokeGetClientProgramList(client_id);
        var programs_data = results.programs;
        var lgth = programs_data.length;
        if(lgth > 0 )
                for(var key in programs_data) {
                        //var date       = new Date(programs_data[key].date_created).toString().slice(0, 15);
                        var date        = programs_data[key].date_created;
                        var name        = programs_data[key].name;
                        var program_id  = programs_data[key].uid;
                        var is_template = false;
                        var member_url  = '/client/detail/'+program_id+'/'+is_template+'/'+client_name+'/'+client_id;
                        var new_date    = new Date(date).toLocaleString([], {month: 'short', day:'2-digit'}); //, hour: '2-digit', minute:'2-digit'});

                        program_list_arr.push({
                              id: uniqueId(), // id is required for unique keys, otherwise there's an error
                              program_name: name,
                              link:         <span style = {{position:"relative",left:"40%", cursor: "pointer"}}
                                                  href  = {member_url}
                                                  onClick={this.props.handleViewProgram.bind(this,member_url)}>
                                                  <FontAwesomeIcon key={uniqueId()} icon="link" style={{fontSize:22}}/>
                                            </span>,
                              overview:     <span style={{position:"relative",left:"40%", cursor: "pointer"}}
                                                  onClick={this.handleShowProgramOverview.bind(this, program_id)}>
                                                  <FontAwesomeIcon key={uniqueId()} icon="file-powerpoint" style={{fontSize:26}}/>
                                            </span>,
                              date:         new_date
                        })
                } // end for
        else {
            program_list_arr.push({
                  id: uniqueId(), // id is required for unique keys, otherwise there's an error
                  program_name: "There are no programs."
            })
        }


        // DO NOT remove this setState, it is required otherwise the data does not load in the table //
        this.setState({
            isLoading: false
        })
    }

    async handleShowProgramOverview (program_id) {
        var results      = await invokeGetProgramOverview(program_id);
        //var program_name = results.data.program_name;

        this.setModalProgramOverviewProps("Program Overview", program_id); // title_text, body_text, show_modal
    }

    ////   SHOW THE ALERT MODAL   ////
    setModalProgramOverviewProps = (title_text, program_id) => {

        this.setState({
            modalTitleText: title_text,
            modalProgramId:  program_id,
            showModalProgramOverview:  true, // true | false
        })
    }

    ////   SHOW THE ALERT MODAL   ////
    /*setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }*/

    renderHome() {

        return (
              <div className="programs">
                    <br/><br/>
                    <BootstrapTable keyField  = "id"
                                    key       = {uniqueId()}
                                    data      = { program_list_arr }
                                    columns   = { columns_prog }
                                    striped hover
                                    //selectRow = { selectRow }
                                    />
              </div>
        );
    }

    render() {
        let closeModalAlert           = () => this.setState({ showModalAlert: false }); //close simple modal window
        let closeModalTrainerTextMsg  = (error) => this.setState({ showModalTrainerTextMsg: false, error: error }); //close modal window
        let closeModalProgramOverview = () => this.setState({ showModalProgramOverview: false }); //close simple modal window

        return (
              <div className="Home">
                {this.renderHome()}

                  {this.state.showModalAlert ?
                      <ModalAlert
                          onHide         = {closeModalAlert}
                          alertFunction  = {this.alertFunction}     // custom function to call within modal
                          alertAction    = {this.state.alertAction} // flag used for above function
                          alertObject    = {this.state.alertObject} // vars used for above function
                          showModalAlert = {this.state.showModalAlert}
                          messageTitle   = {this.state.modalAlertTitleText}
                          messageBody    = {this.state.modalAlertBodyText}
                      />
                  : null}
                  {this.state.showModalProgramOverview ?
                      <ModalProgramOverview
                          onHide         = {closeModalProgramOverview}
                          showModalProgramOverview = {this.state.showModalProgramOverview}
                          messageTitle   = {this.state.modalTitleText}
                          clientId       = {this.props.clientId}
                          modalProgramId = {this.state.modalProgramId}
                      />
                  : null}
                {this.state.showModalTrainerTextMsg ?
                      <ModalTrainerTextMsg
                          onHide                  = {closeModalTrainerTextMsg}
                          trainerId               = {this.state.trainerId}
                          trainerName             = {this.state.trainerName}
                          trainerPhone            = {this.state.trainerTextPhone}
                          athleteId               = {this.state.athleteId}
                          athleteName             = {this.state.athleteName}
                          athleteLastLogin        = {this.state.athleteLastLogin}
                          programName             = {this.state.programName}
                          showModalTrainerTextMsg = {this.state.showModalTrainerTextMsg}
                      />
                 : null}
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/components/client/TableClientProgram.js